<template lang="pug">
img(
  :srcset="`${getImgUrl} 1x,${getImgUrl2x} 2x,${getImgUrl3x} 3x`",
  :src="getImgUrl"
)
</template>

<script>
export default {
  name: "MediaImg",
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    getImgUrl() {
      //檔案路徑, 是否遍歷, regExp
      var images = require.context("@/assets/img/media", false, /\./);
      return images("./" + this.imgUrl + ".png");
    },
    getImgUrl2x() {
      //檔案路徑, 是否遍歷, regExp
      var images = require.context("@/assets/img/media", false, /\./);
      return images("./" + this.imgUrl + "@2x.png");
    },
    getImgUrl3x() {
      //檔案路徑, 是否遍歷, regExp
      var images = require.context("@/assets/img/media", false, /\./);
      return images("./" + this.imgUrl + "@3x.png");
    },
  },
};
</script>

<style scoped>
</style>
